(() => {
  if (window.__dwilJudgeMeMediaReady) return;
  window.__dwilJudgeMeMediaReady = true;

  const mediaSelector = [
    '.jdgm-rev__pic-img[data-src]',
    '.jdgm-rev__pic-img[data-lazy-src]',
    '.jdgm-rev__pic-img[data-original]',
    '.jdgm-gallery__thumbnail[data-src]',
    '.jdgm-gallery__thumbnail[data-lazy-src]',
    '.jdgm-gallery__thumbnail[data-original]',
  ].join(',');
  const widgetSelector = '.jdgm-review-widget';
  const smallViewport = window.matchMedia('(max-width: 767px)');
  const observedAttribute = 'data-dwil-judge-me-observed';
  const requestedAttribute = 'data-dwil-judge-me-requested';
  let scanFrame = null;

  const getImageSource = (image) =>
    image.dataset.src || image.dataset.lazySrc || image.dataset.original || '';

  const finishLoadingState = (image) => {
    image
      .closest('.jdgm-rev__pic-link, .jdgm-gallery__thumbnail-wrapper')
      ?.classList.remove('jdgm--loading');
  };

  const requestImage = (image) => {
    if (!(image instanceof HTMLImageElement) || image.hasAttribute(requestedAttribute)) return;

    const source = getImageSource(image);
    if (!source) return;

    image.setAttribute(requestedAttribute, 'true');
    image.decoding = 'async';

    const sourceSet = image.dataset.srcset || image.dataset.lazySrcset;
    if (sourceSet && !image.getAttribute('srcset')) image.srcset = sourceSet;

    if (image.complete && image.naturalWidth > 0) {
      finishLoadingState(image);
      return;
    }

    image.addEventListener('load', () => finishLoadingState(image), { once: true });
    if (!image.getAttribute('src')) image.src = source;
  };

  const scrollRoot = document.querySelector('.page-wrapper');
  const imageObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const image = entry.target.matches(mediaSelector)
              ? entry.target
              : entry.target.querySelector(mediaSelector);
            if (image) requestImage(image);
            observer.unobserve(entry.target);
          });
        },
        {
          root: scrollRoot,
          rootMargin: '600px 0px',
          threshold: 0,
        }
      )
    : null;

  const observeImage = (image) => {
    if (!(image instanceof HTMLImageElement) || image.hasAttribute(observedAttribute)) return;

    image.setAttribute(observedAttribute, 'true');

    if (image.complete && image.naturalWidth > 0) {
      finishLoadingState(image);
      return;
    }

    if (!imageObserver) {
      requestImage(image);
      return;
    }

    imageObserver.observe(
      image.closest('.jdgm-rev__pic-link, .jdgm-gallery__thumbnail-link') || image
    );
  };

  const syncWidgetLayout = (widget) => {
    if (!(widget instanceof HTMLElement)) return;

    // Judge.me occasionally measures the widget before the PDP section has its
    // final width and leaves its mobile class on a full-width desktop widget.
    // Keep Judge.me's own responsive class and native CSS in sync with the
    // breakpoint used by its stylesheet instead of restyling the gallery.
    widget.classList.toggle('jdgm-review-widget--small', smallViewport.matches);
  };

  const scanForJudgeMeContent = () => {
    scanFrame = null;
    document.querySelectorAll(widgetSelector).forEach(syncWidgetLayout);
    document.querySelectorAll(mediaSelector).forEach(observeImage);
  };

  const queueScan = () => {
    if (scanFrame !== null) return;
    scanFrame = requestAnimationFrame(scanForJudgeMeContent);
  };

  const containsJudgeMeContent = (node) =>
    node instanceof Element
    && (
      node.matches(`${widgetSelector}, ${mediaSelector}`)
      || Boolean(node.querySelector(`${widgetSelector}, ${mediaSelector}`))
    );

  const mutationObserver = new MutationObserver((mutations) => {
    const shouldScan = mutations.some((mutation) => {
      if (mutation.type === 'attributes') {
        return mutation.target.matches(`${widgetSelector}, ${mediaSelector}`);
      }
      return Array.from(mutation.addedNodes).some(containsJudgeMeContent);
    });

    if (shouldScan) {
      queueScan();
    }
  });

  const initialize = () => {
    queueScan();
    mutationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-src', 'data-lazy-src', 'data-original'],
      childList: true,
      subtree: true,
    });
    smallViewport.addEventListener?.('change', queueScan);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
